/**
 * Feature Flags para controle de rollout gradual
 * Permite habilitar/desabilitar funcionalidades durante transição
 */

export const FEATURE_FLAGS = {
  /**
   * Storage unificado ativo
   * Quando true, usa storage.ts para todas as operações
   */
  UNIFIED_STORAGE: true,
  
  /**
   * Dual-write habilitado
   * Quando true, escreve em chaves novas + antigas simultaneamente
   * Garante compatibilidade durante migração
   */
  DUAL_WRITE_ENABLED: true,
  
  /**
   * Leitura de chaves legadas habilitada
   * Quando true, permite fallback para chaves antigas
   * Permite migração gradual sem quebrar sessões ativas
   */
  LEGACY_READ_ENABLED: true,
  
  /**
   * Logs de migração habilitados
   * Quando true, envia logs de migrações para terminal
   * Útil para debug e monitoramento
   */
  MIGRATION_LOGGING: true,
  
  /**
   * Usar action unificada do C# para pipeline de preparação de pedidos
   * Quando true, substitui toda a pipeline tradicional (organizar camadas,
   * distribuir objetos, monitorar, sincronizar) por uma única action no C#
   * que retorna todos os dados necessários para carregar o OrderDetailsPage
   * 
   * ⚠️ EXPERIMENTAL: Esta flag está em fase de teste
   * Se a action falhar ou não retornar dados válidos, o sistema fará
   * fallback automático para a pipeline tradicional
   */
  USE_UNIFIED_PIPELINE_ACTION: true,
} as const;

export default FEATURE_FLAGS;

